import userRoutes from './user'
import accountRoutes from './account'
import servicesRoutes from './services'
import settingRoutes from './settings'
import rightsRoutes from './rights'
import administrationRoutes from './administration'
import routingRoutes from './routing'
import securityRoutes from './security'
import trackingRoutes from './tracking'
import annuaireRoutes from './annuaire'
import orphanRoutes from './orphan'
import monitoringRoutes from './monitoring'
import emailRoutes from './email'
import alertsRoutes from './alerts'
import bicRoutes from './bic'
import entityAccountRoutes from './entityAccount'
import vopProviderRoutes from './vopProvider'
import toolboxRoutes from './toolbox'
import accountTBRoutes from "@/routes/accountTB"
import epcRoutes from '@/routes/epc'
import testCaseReport from '@/routes/testCaseReport'
import globalConfigRoutes from './globalConfig'
import testCaseRequestedRoutes from './testCaseRequested'
import entityGroupRoutes from './entityGroup'
import accessibiliteRoutes from './accessibilite'
import sitemapRoutes from './sitemap'

export default [
  ...servicesRoutes,
  ...userRoutes,
  ...settingRoutes,
  ...accountRoutes,
  ...rightsRoutes,
  ...administrationRoutes,
  ...routingRoutes,
  ...securityRoutes,
  ...monitoringRoutes,
  ...emailRoutes,
  ...alertsRoutes,
  ...bicRoutes,
  ...trackingRoutes,
  ...annuaireRoutes,
  ...orphanRoutes,
  ...monitoringRoutes,
  ...entityAccountRoutes,
  ...vopProviderRoutes,
  ...accountTBRoutes,
  ...epcRoutes,
  ...accessibiliteRoutes,
  ...sitemapRoutes,
  ...globalConfigRoutes,
  ...toolboxRoutes,
  ...accountTBRoutes,
  ...epcRoutes,
  ...testCaseReport,
  ...testCaseRequestedRoutes,
  ...entityGroupRoutes
]
